export default __webpack_public_path__ + "static/media/Cuirass of the Fallen Empire.d8731e76.jpg";